import router from "./router";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import axios from "axios";
axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem("token") || null;
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
console.log(router.currentRoute.fullPath);
axios.interceptors.response.use(
  function(response) {
    // token 已过期，重定向到登录页面
    if (response.data.code == 403) {
      localStorage.clear();
      router.replace({
        path: "/login",
        query: { redirect: router.currentRoute.fullPath }
      });
    }
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

router.beforeEach((to, from, next) => {
  // 权限路由控制
  NProgress.start();
  if (!localStorage.getItem("token") && to.path != "/login") {
    next(`/login?redirect=${to.path}`);
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});
